<div class="claim-list" data-cy="claimList" [ngClass]="{ 'sidebar-present': sidebarPresent }">
  @if (!!rows?.length) {
    <ngx-datatable
      class="none md-block"
      [ngClass]="cssClasses"
      [cssClasses]="{
        pagerLeftArrow: 'icon-chevron-left',
        pagerRightArrow: 'icon-chevron-right',
        pagerPrevious: 'icon-arrow-left-double',
        pagerNext: 'icon-arrow-right-double'
      }"
      [rows]="rows"
      [columns]="columns"
      [columnMode]="'force'"
      [headerHeight]="60"
      [rowHeight]="'auto'"
      [scrollbarH]="true"
      [limit]="pageLimit"
      [footerHeight]="footerHeight"
    >
    </ngx-datatable>
  }

  @if (!!rows?.length) {
    <ds-table
      class="block md-none"
      [ngClass]="{ 'mobile-only': sidebarPresent }"
      [rows]="rows"
      [columns]="columns"
      [headerHeight]="60"
      [tableClasses]="'action-row'"
    >
    </ds-table>
  }
</div>

<ng-template #headerCellTpl let-column="column" let-row="row">
  <div class="header-cell table-header-cell-wrapper">
    @if (isDraft && column?.prop === 'claimName') {
      <span>Draft</span>
    }
    @if (isDraft && column?.prop === 'submitDate') {
      <span>Incident Date</span>
    }
    @if (!isDraft || (column?.prop !== 'claimName' && column?.prop !== 'submitDate')) {
      <span>{{ column?.name }}</span>
    }
  </div>
</ng-template>

<ng-template #claimNameCellTpl let-row="row">
  @if (!!row) {
    <div class="method-details-cell ds-table-body-cell-header-wrapper">
      @if (row?.claimName) {
        <div class="ds-table-body-cell-header">
          @if (row?.isDraft) {
            <h3 class="margin-0">
              @if (row?.isValidRisk) {
                <a
                  title="{{ row.claimName }} - {{ row.riskDescription }}"
                  [ngClass]="{ disabled: !roleService.isAuthorized('fnolform_retreive') | async }"
                  (click)="resumeDraftClaim(row)"
                  [attr.data-cy]="'draftClaimListHeaderLinkFor_' + row.claimNumber"
                >
                  {{ row.claimName }} - {{ row.riskDescription }}
                </a>
              }
              @if (!row?.isValidRisk) {
                <span> {{ row.claimName }} </span>
              }
            </h3>
          }
          @if (!row?.isDraft) {
            <h3 class="margin-0">
              @if (row?.isValidRisk) {
                <a
                  title="{{ row.claimName }} - {{ row.riskDescription }}"
                  (click)="routeToClaimEvent.emit(row.claimNumber)"
                  [attr.data-cy]="'claimListDetailsHeaderLinkFor_' + row.claimNumber"
                >
                  {{ row.claimName }} - {{ row.riskDescription }}
                </a>
              }
              @if (!row?.isValidRisk) {
                <span> {{ row.claimName }} </span>
              }
            </h3>
          }
        </div>
      }
      @if (row?.claimName || row?.isValidRisk) {
        <div class="table-body-cell-label-content flex-direction-column">
          @if (row?.claimName && row?.isDraft) {
            <p
              class="fill margin-0"
              authCheck
              [permissionName]="'fnolform_retreive'"
              [checkAction]="'disable'"
            >
              @if (row?.isValidRisk) {
                <a
                  title="{{ row.claimName }}"
                  (click)="resumeDraftClaim(row)"
                  [attr.data-cy]="'draftClaimResumeFor_' + row.claimNumber"
                  data-cy="draftClaim"
                >
                  <span class="h3">{{ row.claimName }}</span>
                </a>
              }
              @if (!row?.isValidRisk) {
                <span class="h3">{{ row.claimName }}</span>
              }
            </p>
          }
          @if (row?.claimName && !row?.isDraft) {
            <p class="fill margin-0">
              @if (row.showViewDetailBtn) {
                <a
                  title="{{ row.claimName }}"
                  (click)="routeToClaimEvent.emit(row.claimNumber)"
                  [attr.data-cy]="'claimListDetailsLinkFor_' + row.claimNumber"
                >
                  <span class="h3">{{ row.claimName }}</span>
                </a>
              }
              @if (!row.showViewDetailBtn) {
                <span class="h3">{{ row.claimName }}</span>
              }
            </p>
          }
          @if (row?.isValidRisk) {
            <p class="fill margin-0">{{ row.riskDescription }}</p>
          }
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #submitDateCellTpl let-row="row">
  @if (!!row && ((row?.isDraft && row?.incidentDate) || (!row?.isDraft && row?.submitDate))) {
    <span>{{ row?.isDraft ? row.incidentDate : row?.submitDate }}</span>
  }
</ng-template>

<ng-template #statusCellTpl let-row="row">
  @if (!!row) {
    <div>
      @if (row?.useProgressTrackingIndicator && row?.claimSteps) {
        <ds-progress-indicator [steps]="row.claimSteps" [mini]="true"></ds-progress-indicator>
      }
      @if (!row.useProgressTrackingIndicator && row?.status) {
        <span>{{ row.status }}</span>
      }
    </div>
  }
</ng-template>

<ng-template #actionCellTpl let-row="row">
  @if (!!row) {
    <div class="flex items-center fill justify-flex-end">
      @if (row?.isDraft && !hideDelete) {
        <a
          class="error-600-text caption pad-right-10"
          title="Delete Draft"
          (click)="openDeleteDraftClaimModal(row)"
          [attr.data-cy]="'claimsListDeleteDraftClaimLinkFor_' + row.claimNumber"
        >
          Delete
        </a>
      }
      @if (row?.isDraft && row?.isValidRisk) {
        <button
          ds-button
          class="-outline-white"
          authCheck
          [permissionName]="'fnolform_retreive'"
          [checkAction]="'disable'"
          (click)="resumeDraftClaim(row)"
          [dsAnalyticsClick]="resumeDraftAnalytic.link"
          [attr.data-cy]="'claimsListResumeDraftClaimButtonFor_' + row.claimNumber"
        >
          Resume
        </button>
      }
      @if (row?.isDraft && !row?.isValidRisk) {
        <button
          ds-button
          class="-outline-white"
          [dsRouterLink]="['/claims/report-claim-fnol/call-us']"
          [attr.data-cy]="'claimsListMoreInfoButtonFor_' + row.claimNumber"
        >
          More Info
        </button>
      }
      @if (!row.isDraft && row.showViewDetailBtn) {
        <button
          ds-button
          class="-outline-white"
          (click)="routeToClaimEvent.emit(row.claimNumber)"
          [attr.data-cy]="'claimsListDetailsButtonFor_' + row.claimNumber"
        >
          View Details
        </button>
      }
      @if (!row.isDraft && !row.showViewDetailBtn) {
        <span class="primary-800-text pad-right-10">Processing</span>
      }
    </div>
  }
</ng-template>

<ng-template #deleteModalTpl>
  <h1 class="error-600-text">Delete Saved Draft on {{ selectedDraftClaim?.riskDescription }}?</h1>
  @if (!!selectedDraftClaim?.claimObj?.openDate) {
    <p class="pad-bottom-10">
      Last saved on {{ selectedDraftClaim?.claimObj?.openDate | dateFormat }}
    </p>
  }
  @if (!selectedDraftClaim?.claimObj?.openDate && !selectedDraftClaim?.claimObj?.lossDate) {
    <p class="pad-bottom-10">
      Last saved on {{ selectedDraftClaim?.claimObj?.lossDate | dateFormat }}
    </p>
  }
  <p class="pad-bottom-20">
    If you delete this draft, any information you've entered will be lost.
  </p>
  <button ds-button class="-outline -error" type="button" (click)="deleteDraftClaim()">
    Delete Draft
  </button>
  <button
    ds-button
    class="margin-left-10 -outline-white"
    type="button"
    (click)="closeDeleteDraftClaimModal()"
  >
    Cancel
  </button>
</ng-template>

@if (selectedDraftClaim) {
  <ds-modal [id]="modalId" [maxWidth]="767" (onCloseModalEvent)="clearSelectedDraftClaim()">
    <ng-template [ngTemplateOutlet]="deleteModalTpl"> </ng-template>
  </ds-modal>
}
